module.exports = __webpack_public_path__ + "img/button_image13.df67bc52.jpg";